var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('card-list-info',{attrs:{"header":"Prestart Detail","items":_vm.detailInfo}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('card-list-info',{attrs:{"header":"Company Information","items":_vm.companyInfo}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f11ae84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/question_prestart/detail/Index.vue
// module id = 2388
// module chunks = 0